import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Select from 'react-select';
import {updateUserSetting} from '../../../redux/actions/userAction';

class RepresentativeClientSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_profile: false,
            image: null,
            uploading: false,
        }

    }

    componentDidMount() {

        let user_profile = this.props.user.user_profile.selectedRepresentativeProfile;

        user_profile.user_id = this.props.user.user_id;
        this.setState({
            user_profile: user_profile,
            user_id: this.props.user.user_id
        })

        document.querySelector('title').innerHTML = 'MijnDP - Instellingen';
    }

    UNSAFE_componentWillMount() {

        let settings = {
                email_preference: 'URGENT_MAIL'
            };
        if(this.props.user.user_profile.selectedRepresentativeProfile.user_settings) {
            if(this.props.user.user_profile.selectedRepresentativeProfile.user_settings.email_preference) {
                settings = { email_preference: this.props.user.user_profile.selectedRepresentativeProfile.user_settings.email_preference }
            }
        }

        this.setState({
            settings : settings
        })


    }

    handleSubmit() {
        this.props.updateUserSetting(this.props.clientPath + '/api/user/action/updateSettings', this.props.user.user_profile.user_id, this.state.settings);
    }

    _emailPreferenceChanged(value) {
        this.setState({
            settings : {
                email_preference: value
            }
        })
    }

    render() {
        const emailSettings = [
            {label: 'Ontvang alle berichten per mail', value: 'ALL_MAIL'},
            {label: 'Ontvang urgente berichten per mail', value: 'URGENT_MAIL'},
            {label: 'Ontvang niets per mail', value: 'NO_MAIL'}
        ]
        return (


              <div>
                <div className="column column--12">
                    <div className="card">

                        <div className="card__header">
                          <h1>Bericht instellingen</h1>
                        </div>

                        <div className="card__body">
                            <div className="card__content">
                            <Select
                                            closeOnSelect={true}

                                            disabled={false}
                                            onChange={value => this._emailPreferenceChanged(value)}
                                            options={emailSettings}
                                            placeholder="E-mail instellingen"
                                            rtl={this.state.rtl}
                                            value={this.state.settings.email_preference}

                                                        />

                            <div className="floating__button floating__button--right">
                                                <RaisedButton disabled={true} onClick={() => this.handleSubmit()} label="Opslaan" primary={true} fullWidth={true}/>
                                            </div>

                       </div>
                    </div>
                </div>
            </div>
        </div>

        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {

        updateUserSetting: (url, user_id, settings) => dispatch(updateUserSetting(url, user_id, settings)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RepresentativeClientSettings));



// WEBPACK FOOTER //
// ./src/components/User/Settings/RepresentativeClientSettings.js